import { Dayjs } from "dayjs";

// 新形式を作り始めた最初の初期値。これより前は旧形式へ直行し、
// 存在しない PMTiles を先読みしない。境界以降でも個別ファイルが欠ける場合は、
// 各ローダが旧形式へフォールバックする。
export const SHADE_PMTILES_CUTOFF: Record<string, string> = {
    MSM: "20260707-15",
    QMA: "20260709-01",
    GSA: "00000000-00",
    GSL: "00000000-00",
    MSG: "00000000-00",
    default: "20260708-15",
};

export const WIND_PMTILES_CUTOFF: Record<string, string> = {
    GSM: "20260711-15",
    GS5: "20260711-15",
    MSM: "20260711-18",
    LFM: "20260711-15",
    QMA: "20260711-15",
    GSA: "00000000-00",
    GSL: "00000000-00",
};

export const CONTOUR_PMTILES_CUTOFF = "20260712-15";
export const QMA_CONTOUR_PMTILES_DIRECTORY_CUTOFF = "20260711-00";

export function beforeInitialCutoff(initial: Dayjs, cutoff: string) {
    return initial.format("YYYYMMDD-HH") < cutoff;
}
